import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';

import App from './App';
import { ChakraProvider } from '@chakra-ui/react';
import { AuthProvider } from 'react-auth-kit';
import Checkbox from '@mui/material/Checkbox';
import {
  createTheme,
  ThemeProvider as MaterialThemeProvider,
  createTheme as muiCreateTheme,
  THEME_ID,
} from '@mui/material/styles';

import { orange } from '@mui/material/colors';
import refreshApi from 'authUtils/refreshTokenApi';
import { COLORS } from 'constant/COLORS';
import React, { createContext, useState, Suspense } from 'react'; // Importez Suspense ici
// Importez votre fichier de configuration i18n
import './i18n'; // Assurez-vous que le chemin est correct

const root = ReactDOM.createRoot(document.getElementById('root'));
// Import the functions you need from the SDKs you need

const materialTheme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(ownerState.variant === 'contained' &&
            ownerState.color === 'primary' && {
              backgroundColor: COLORS.PRIMARY,
              color: '#fff',
            }),
        }),
      },
    },
  },
});

export const SidebarContext = createContext(undefined);

const SidebarProvider = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const toggleSidebar = (value) => {
    value ? setIsCollapsed(value === 'close') : setIsCollapsed(!isCollapsed);
  };

  const contextValue = {
    isCollapsed,
    toggleSidebar,
  };

  return React.createElement(SidebarContext.Provider, { value: contextValue }, children);
};

root.render(
  <BrowserRouter>
    <ChakraProvider>
      <MaterialThemeProvider theme={{ [THEME_ID]: materialTheme }}>
        <AuthProvider
          authType={'localstorage'}
          authName={'_auth'}
          // cookieDomain={window.location.hostname}
          // cookieSecure={window.location.protocol === "https:"}
          refresh={refreshApi}
        >
          <SidebarProvider>
            {/* Encapsulez votre App dans Suspense pour gérer le chargement d'i18next */}
            <Suspense fallback={<div>Chargement des traductions...</div>}>
              <App />
            </Suspense>
          </SidebarProvider>
        </AuthProvider>
      </MaterialThemeProvider>
    </ChakraProvider>
  </BrowserRouter>
);
